import { z } from "zod";
export const LOCALES = ["en", "zh"];
export const Locale = z.enum(LOCALES).meta({ id: "Locale" });
/** English is required; other phase-1 locales are optional and fall back to English. */
export const LocalizedText = z
    .object({ en: z.string().min(1), zh: z.string().min(1).optional() })
    .meta({ id: "LocalizedText" });
//# sourceMappingURL=localized-text.js.map